var map = {
	"./daka.svg": "XCHT",
	"./example.svg": "OOLB",
	"./eye-open.svg": "no6o",
	"./eye.svg": "4wdf",
	"./form.svg": "sTIr",
	"./link.svg": "KgwQ",
	"./nested.svg": "798r",
	"./password.svg": "QjmH",
	"./table.svg": "oSYw",
	"./tree.svg": "3eCm",
	"./user.svg": "VdD3",
	"./zhanwajue.svg": "XPtW",
	"./zhihui.svg": "q7sS"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 53